import React from 'react'
import { Modal } from '@mui/material'
import LogoShellma from '../assets/images/Loga/PersonalLogo.png'
import LogoGympl from '../assets/images/Loga/GymplLogo.png'
import LogoMaro from '../assets/images/Loga/maroIcon.png'
import LogoGloryFightClub from '../assets/images/Loga/GloryFightClub.png'

const MobileFooter: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = React.useState(false)

    // Check if current time is Monday-Friday between 14:00 and 22:00
    const isBusinessHours = (): boolean => {
        const now = new Date()
        const dayOfWeek = now.getDay() // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
        const hour = now.getHours()

        // Monday (1) to Friday (5) between 14:00 and 22:00
        return dayOfWeek >= 1 && dayOfWeek <= 5 && hour >= 14 && hour < 22
    }

    const showPhoneNumber = isBusinessHours()

    return (
        <>
            {/* Modal for phone number */}
            <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90vw',
                        maxWidth: 400,
                        backgroundColor: '#241823',
                        color: '#FFF6FF',
                        padding: 32,
                        borderRadius: 20,
                        boxShadow: '0px 0px 30px rgba(191, 61, 201, 0.8)',
                        outline: 'none',
                        border: 'none',
                    }}
                >
                    <div className='absolute text-2xl text-gray-300 right-4 top-4 cursor-pointer'>
                        <span onClick={() => setIsModalOpen(false)}>×</span>
                    </div>
                    <h3 className='text-secondary text-3xl font-bold text-center mb-4 not-italic underline'>
                        Volat pondělí až pátek po 14. hodině
                    </h3>
                    <div className='flex flex-col items-center justify-center text-center'>
                        <a href='tel:724 790 187' className='text-secondary text-xl text-center mb-6 w-fit'>
                            724 790 187
                        </a>
                        <button
                            onClick={() => setIsModalOpen(false)}
                            className='w-full bg-primary text-secondary px-4 py-2 rounded-lg font-bold hover:bg-primary/80 transition-colors'
                        >
                            Zavřít
                        </button>
                    </div>
                </div>
            </Modal>
            <div
                style={{ height: 'calc(100% + 18px)' }}
                className='w-full lg:w-2/3 lg:absolute right-[-100px] top-[-12px] px-10 border-primary border-t-4 pb-10'
                id='contact'
            >
                <div className={`w-full h-full pt-2`}>
                    <div className='text-secondary text-3xl font-bold'>
                        Autoškola <span className='text-primary'>eRko</span>
                    </div>
                    <div className={`w-full h-full flex flex-col lg:flex-col lg:items-center pt-[10px]`}>
                        <div className=''>
                            <div className='text-secondary text-xl font-bold mt-2'>Kontakt</div>
                            <div className='text-secondaryDark font-bold '>
                                <span className='text-secondary'>Jméno:</span>
                                Richard Melicher
                            </div>
                            <div className='text-secondaryDark font-bold '>
                                <span className='text-secondary'>Učebna teorie:</span> Gymnázium Jirkov, Mostecká 35, Jirkov
                            </div>
                            <div className='text-secondaryDark  font-bold '>
                                <span className='text-secondary'>Sídlo firmy:</span> Jasmínová 5893, 430 04 Chomutov
                            </div>
                            <div className='text-secondaryDark  font-bold '>
                                <span className='text-secondary'>Telefon pro nové žadatele:</span>{' '}
                                {showPhoneNumber ? (
                                    <a href='tel:724 790 187'>724 790 187</a>
                                ) : (
                                    <button
                                        onClick={() => setIsModalOpen(true)}
                                        className='text-primary underline hover:text-primary/80 transition-colors'
                                    >
                                        klikni zde
                                    </button>
                                )}{' '}
                                (<span className='text-secondary not-italic underline'>po-pá po 14. hodině</span>)
                            </div>
                            <div className='text-secondaryDark  font-bold'>
                                <span className='text-secondary'>Email:</span>{' '}
                                <a href='mailto:autoskolaerko@seznam.cz'> autoskolaerko@seznam.cz</a>
                            </div>
                        </div>
                        <div className=''>
                            <div className='text-secondary text-xl font-bold mt-6'>Spolupracujeme</div>
                            <div className='flex w-full justify-between flex-wrap space-x-2 space-y-3'>
                                <img
                                    src={LogoShellma}
                                    alt='LogoShellma'
                                    loading='lazy'
                                    className='object-contain cursor-pointer w-1/3 md:w-1/5'
                                    onClick={() => window.open('https://www.shellma.dev/', '_blank')}
                                />
                                <img
                                    src={LogoGympl}
                                    alt='Městské gymnázium a Základní škola Jirkov'
                                    loading='lazy'
                                    className='object-contain cursor-pointer w-1/3 md:w-1/5'
                                    onClick={() => window.open('http://web.gympljirkov.cz/', '_blank')}
                                />
                                <img
                                    src={LogoMaro}
                                    alt='MARO Kralovice'
                                    loading='lazy'
                                    className='object-contain cursor-pointer w-1/3 md:w-1/5'
                                    onClick={() => window.open('https://www.maro-kralovice.cz/', '_blank')}
                                />
                                <img
                                    src={LogoGloryFightClub}
                                    alt='Glory Fight Club'
                                    loading='lazy'
                                    className='object-contain cursor-pointer w-1/3 md:w-1/5'
                                />
                                {/* <img src={LogoLenkaC} alt="PhDr. Lenka Čermáková" loading='lazy' className='object-cover cursor-pointer w-1/3 md:w-1/5' onClick={() => window.open('https://www.lenkacermakova.eu/', '_blank')} /> */}
                                <div
                                    className='w-1/3 md:w-1/5 bg-secondary p-2 rounded-xl shadow-md shadow-primary cursor-pointer'
                                    onClick={() => window.open('https://www.lenkacermakova.eu/', '_blank')}
                                >
                                    PhDr. Lenka Čermáková <p className='text-sm text-gray-500'>akreditovaný dopravní psycholog</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MobileFooter
